<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={40 * scale} height={40 * scale} viewBox="-10 -10 37 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M0 1C0 0.447716 0.447715 0 1 0C1.55228 0 2 0.447715 2 1V13C2 13.5523 1.55228 14 1 14C0.447715 14 0 13.5523 0 13V1Z" />
  <path fill={color} d="M7.25 8.29904C6.25 7.72169 6.25 6.27831 7.25 5.70096L14.75 1.37083C15.75 0.793484 17 1.51517 17 2.66987V11.3301C17 12.4848 15.75 13.2065 14.75 12.6292L7.25 8.29904Z" />
</svg>
